import React from 'react';
import firebase from '../Firebase';
import { Redirect } from 'react-router-dom';

class VideoNew extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      uploadProgress: 0
    };
    this.props = props;
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      var uid = firebase.auth().currentUser.uid;
      this.setState({ userId: uid });
    });
  }

  handleUpload = () => {
    var files = document.getElementById("files").files;
    var file = files[0];

    if(!file){
      alert("You must select a file");
      return;
    }

    if(this.state.videoName == undefined){
      alert("You must enter a name for your video");
      return;
    }

    var fileName = files[0].name;
    var component = this;

    if (this.state.videoName && files.length > 0) {
      this.createVideoRecord(fileName).then((ref) => {

        var uid = this.state.userId;
        var storageRef = firebase.storage().ref();
        
        var uploadTask = storageRef.child(uid).child(ref.id).child("video.mp4").put(file);
        var component = this;

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
          component.setState({uploading: true});
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes);
          var progressPct = Math.round(progress * 100);
          
          console.log('Upload is ' + progressPct + '% done');
          ref.update({ uploadProgress: progressPct });
          
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused');
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running');
              break;
          }
        }, function (error) {

          ref.delete();

          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;

            case 'storage/canceled':
              // User canceled the upload
              break;

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
          }

        }, function () {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            console.log('File available at', downloadURL);
            ref.update({ videoUrl: downloadURL });
          });
        });
      });
    }
  }

  createVideoRecord = (videoName) => {
    const db = firebase.firestore();
    var uid = this.state.userId;
    return db.collection("users").doc(uid).collection("videos").add({
      videoName: this.state.videoName,
      fileName: videoName
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    if(this.state.uploading){
      return <Redirect to='/videos' />
    }
    
    return (
      <div>
        <h1>Upload new video</h1>
        <input type="text" name="videoName" onChange={this.handleInputChange} /><br />
        <input type="file" id="files" name="files[]" multiple /><br />
        <button onClick={this.handleUpload}>Save</button><button>Cancel</button>
      </div>
    )
  }
}

export default VideoNew;